import { multUnit, sumUnits, unit } from '@othrworld/units';
export const radialToCarth = ({ angle, r, }) => ({
    x: multUnit(r, Math.cos(angle)),
    y: multUnit(r, Math.sin(angle)),
});
export const carthToRadial = (vec) => ({
    r: getLen(vec),
    angle: Math.atan2(vec.y, vec.x),
});
// unused
export const rotateCarth = (coords, angle) => {
    const radial = carthToRadial(coords);
    radial.angle += angle;
    return radialToCarth(radial);
};
export const getLen = (vec) => unit(Math.hypot(vec.x, vec.y));
export const sumVector = (...vecs) => ({
    x: sumUnits(...vecs.map((v) => v.x)),
    y: sumUnits(...vecs.map((v) => v.y)),
});
export const multVector = (vec, fac) => ({ x: multUnit(vec.x, fac), y: multUnit(vec.y, fac) });
export const unitVector = (vec) => multVector(vec, 1 / getLen(vec));
//# sourceMappingURL=coords.js.map